import { render, staticRenderFns } from "./modifier-group-details-translation-form.vue?vue&type=template&id=22a01f72"
import script from "./modifier-group-details-translation-form.vue?vue&type=script&lang=js"
export * from "./modifier-group-details-translation-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports